import { HttpClient } from '@angular/common/http';
import { OnInit, OnChanges, SimpleChanges, AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GoogleMapsApiLoaderService } from '../GoogleMapsApiLoaderService';
import NavMenuService from '../navigation-menu/nav-menu-service';



declare var google : any;


@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
	mobileMenuVisible : boolean = false;
	gmapsLoaderSubscription : Subscription;

	constructor(private httpClient: HttpClient,
		private googleMapsApiLoaderService : GoogleMapsApiLoaderService,
		private navMenuService : NavMenuService)
	{	
		this.loadGoogleMapsApi();
	}

	private loadGoogleMapsApi = () => {
		this.gmapsLoaderSubscription = this.httpClient
			.jsonp(
				`https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&language=en`,
				'callback'
			).subscribe({
				next : (result) => {
					this.googleMapsApiLoaderService.googleMapsApiLoaded$.next(true);
					console.debug("Google maps script loaded");									
				},
				error : (ex) => {
					console.debug(`[ Exception loading google maps script reference : ${ex.message} ]`);
					this.googleMapsApiLoaderService.googleMapsApiLoaded$.next(false);
				},
				complete : () => {
					
				}
			});
	}
	
	private callback = function(data : any) {
		console.log(data);
	}

	ngOnInit(): void {
		
		this.navMenuService.getActivated().subscribe({
			next : (value : boolean) => {
				this.mobileMenuVisible = value;
			}
		});	
	}

	ngOnDestroy(): void {
		this.gmapsLoaderSubscription && this.gmapsLoaderSubscription.unsubscribe();		
	}

	ngOnChanges(changes: SimpleChanges): void {
		
	}

	ngAfterViewInit(): void {
		google?.charts?.load('current', {packages: ['corechart', 'scatter', 'line']});
	}
}
